import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../../../components/molecules/Navbar";
import Footer from "../../../components/molecules/Footer";
import styles from "../index.module.css";

function EligibilityCongratulations() {
  const location = useLocation();
  const navigate = useNavigate();

  const userData =
    location.state?.data ||
    JSON.parse(sessionStorage.getItem("eligibility_data") || "{}");

  const handleProceed = () => {
    // navigate("/eligibility/sanction-details", { replace: true, state: { data: userData } });
    navigate("/eligibility/kfs", { replace: true, state: { data: userData } });
  };

  return (
    <div className={styles.body}>
      <div className={styles.backdrop}>
        <Navbar />
        <div className={styles.main}>
          <div className={styles.cardWrapper}>
            <div className={styles.container}>

              {/* ── Badge ── */}
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", paddingTop: "0.5rem", paddingBottom: "0.6rem" }}>
                <div
                  style={{
                    width: "72px",
                    height: "72px",
                    borderRadius: "20px",
                    background: "linear-gradient(135deg, #d32028 0%, #a01820 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 8px 24px rgba(211,32,40,0.28)",
                    marginBottom: "1rem",
                  }}
                >
                  <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
                    <path d="M19 4L22.5 14.5H34L24.5 21L28 31.5L19 25L10 31.5L13.5 21L4 14.5H15.5L19 4Z" fill="white" opacity="0.95" />
                  </svg>
                </div>

                <p style={{ fontSize: "1.35rem", fontWeight: 800, color: "#1a1a2e", margin: "0 0 0.35rem", fontFamily: "Outfit, sans-serif", textAlign: "center", letterSpacing: "-0.3px" }}>
                  Congratulations!
                </p>
                <p style={{ fontSize: "0.84rem", color: "#777", margin: 0, textAlign: "center", lineHeight: 1.55, whiteSpace: "nowrap" }}>
                  Your loan application has been approved.
                </p>
              </div>

              {/* ── Approved banner ── */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.65rem",
                  background: "#f0fdf4",
                  border: "1px solid #bbf7d0",
                  borderRadius: "10px",
                  padding: "0.8rem 0.9rem",
                }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
                  <path d="M12 2L3 7V12C3 16.55 6.84 20.74 12 22C17.16 20.74 21 16.55 21 12V7L12 2Z" fill="#22c55e" opacity="0.15" stroke="#22c55e" strokeWidth="1.6" />
                  <path d="M9 12L11 14L15 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <p style={{ margin: 0, fontSize: "0.82rem", color: "#166534", lineHeight: 1.55, fontWeight: 500 }}>
                  Your loan is{" "}
                  <strong style={{ color: "#15803d" }}>sanctioned & approved</strong>
                  . Please complete your post approval process.
                </p>
              </div>

            </div>

            {/* ── Proceed button ── */}
            <div style={{ padding: "0rem 1.25rem 1rem", display: "flex", flexDirection: "column", gap: "0.5rem" }}>
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "0.6rem",justifyContent:'center' }}>
                <button
                  onClick={handleProceed}
                  style={{
                    width: "65%",
                    padding: "0.8rem 1.5rem",
                    background: "#d32028",
                    color: "#fff",
                    border: "none",
                    borderRadius: "60px",
                    fontSize: "0.9rem",
                    fontWeight: 700,
                    fontFamily: "Outfit, sans-serif",
                    cursor: "pointer",
                    letterSpacing: "0.3px",
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.5rem",
                  }}
                >
                  Proceed
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12H19M13 6L19 12L13 18" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
                {process.env.REACT_APP_CURRENT !== 'prod' && (
                  <button
                    // onClick={() => navigate("/eligibility/sanction-details", { replace: true, state: { data: userData } })}
                    onClick={() => navigate("/eligibility/kfs", { replace: true, state: { data: userData } })}
                    style={{ background: "none", border: "none", color: "#bbb", fontSize: "0.78rem", cursor: "pointer", fontFamily: "Outfit, sans-serif", textDecoration: "underline" }}
                  >
                    Skip
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
                  <Footer light />

      </div>
    </div>
  );
}

export default EligibilityCongratulations;
